import { checkStaticFlag, featureFlags } from 'client/store/modules/FeatureFlagsModule';
import CollectionApi from 'client/api/v2/CollectionApi';

class RadiusServerApi extends CollectionApi {
  constructor() {
    super('/api/radiusservers', {
      limit: 50,
      search: {
        fields: ['name', 'networkSourceIp'],
        searchTerm: '',
      },
      skip: 0,
      sort: 'name', // Prepend with a '-' to reverse default sort direction
    });
  }

  async initialize() {
    const isV2Api = checkStaticFlag(featureFlags.radiusApiV2);

    if (isV2Api) {
      this.baseUrl = '/api/v2/radiusservers';
    } else {
      this.baseUrl = '/api/radiusservers';
    }
  }
}

export default new RadiusServerApi();
